// extracted by mini-css-extract-plugin
export var full = "loader-module--full--Y1y4C";
export var ldsRipple = "loader-module--lds-ripple--nS3q1";
export var ldsRipple__wrapper = "loader-module--lds-ripple__wrapper--bfb5F";
export var little = "loader-module--little--YqHKs";
export var loadingText = "loader-module--loading-text--fJRBd";
export var noBg = "loader-module--no-bg--s5GPq";